// extracted by mini-css-extract-plugin
export var circle = "_ak-1";
export var exitConfirmationModal = "_ak-5";
export var iframe = "_ak-0";
export var offline = "_ak-3";
export var online = "_ak-2";
export var workstationSelectError = "_ak-4";